import { useDataFormStore } from "@/stores/form";
import { useDataFormStoreApi } from "@/stores/formSave";
import { getPackageKey } from "@/utils/tabsFunctions";
import { watch } from "vue";

export default {
    props: {
        ruleFormRef: Object,
    },

    setup() {

        const dataForm = useDataFormStore();
        const dataFormApi = useDataFormStoreApi();

        var service = "";

        var packages = "";

        watch(dataFormApi, () => {

            /* Услуги */
            service = ""

            // service += (dataFormApi.transportation) ? ", Перевозка между городами" : ""
            // service += (dataFormApi.cargoPickUp) ? ", Забор груза" : ""
            // service += (dataFormApi.extraChargeForCargoPickUp) ? ", Оплата за дальность забора" : ""
            // service += (dataFormApi.cargoDelivery) ? ", Доставка по городу" : ""
            // service += (dataFormApi.extraChargeForCargoDelivery) ? ", Оплата за дальность доставки" : ""
            // service += (dataFormApi.costWarranty) ? ", Гарантийное обязательство" : ""
            // service += (dataFormApi.warmPlace) ? ", Теплое место" : ""
            service += (dataFormApi.cashOnDeliveryAmount) ? ", Комиссия за наложенный платеж" : ""
            service += (dataFormApi.costForTheRedemptionOfCargo) ? ", Комиссия за выкуп груза" : ""
            service += (dataFormApi.costForReturningDocuments) ? ", Возврат документов" : ""
            service = service.slice(2)

            if (service) {
                document.getElementById('usligi-list').parentNode.style.display = "block";
                document.getElementById('usligi-list').innerHTML = service;
            } else {
                document.getElementById('usligi-list').parentNode.style.display = "none";
            }


            /* Упаковки */
            packages = ""

            if (dataForm.cargoInformation.cargoSpaceType == "simple") {
                if (dataForm.packages.additionalPackagingGroup.length != 0) packages = "<div><b>Доп. упаковка: </b>" + dataForm.packages.additionalPackagingGroup.join(", ") + "<br></div>";
            } else {
                dataForm.cargoSpaceTabs.forEach((tab) => {
                    let tabPackage = dataForm.packagesTabs[getPackageKey(tab.name)];
                    if (tabPackage.additionalPackagingGroup.length != 0) packages += "<div><b>Доп. упаковка (" + tab.name + "-е место)</b>" + tabPackage.additionalPackagingGroup.join(", ") + "</div>";
                });
            }

            if (packages) {
                document.getElementById('package-list').style.display = "flex";
                document.getElementById('package-list').innerHTML = packages;
            } else {
                document.getElementById('package-list').style.display = "none";
            }

            if((packages == "") && (service == "")) {
                document.getElementById("uslugi-area").style.display = "none"
            } else {
                document.getElementById("uslugi-area").style.display = "block"
            }
            
        })

        const joinFullName = (surname, firstName, secondName) =>
            `${surname} ${firstName} ${secondName}`;

        return {
            dataForm,
            dataFormApi,
            service,
            lastPageSwitchStyle: function() {},
            joinFullName,
        };
    },
};
